<template>
    <page :tabs="tabs">
        <b-col class="mt-2 col-md-6">
            <b-row class="flex-nowrap">
                <b-col cols="6">
                    <p>
                        <b>{{ question }}</b>
                    </p>
                </b-col>
                <b-col>
                    <p>
                        <b>Color</b>
                    </p>
                </b-col>
                <b-col>
                    <p>
                        <b>Disabled</b>
                    </p>
                </b-col>
            </b-row>
            <b-row v-for="choice in choices" :key="choice.id" class="mb-2">
                <b-col cols="6">
                    <span class="text-break">
                        {{ choice.title }}
                        {{ choice.deleted ? '(Deleted)' : '' }}
                    </span>
                </b-col>
                <b-col>
                    <input
                        class="color-picker"
                        type="color"
                        :value="choice.color"
                        @input="onColorChange($event.target.value, choice.id)"
                        :disabled="choice.disabled"
                    />
                </b-col>
                <b-col>
                    <form-checkbox v-model="choice.disabled" />
                </b-col>
            </b-row>
            <b-button variant="primary" @click="saveAssignments"
                >Save Assignments</b-button
            >
        </b-col>
    </page>
</template>

<script>
import API from '../../../api';
import Page from '../../generic/page/page.vue';
import ResponsiveButton from '../../generic/responsive-button/responsive-button.vue';
import {
    CALENDAR_COLOR_ASSIGNMENT_ENDPOINT,
    CALENDAR_COLOR_ASSIGNMENT_SAVE_ENDPOINT,
    CALENDAR_COLOR_ASSIGNMENT_QUESTION_ENDPOINT,
} from '../../../endpoints';
import FormCheckbox from '../../generic/form-checkbox/form-checkbox.vue';

const DISABLED_INPUT_COLOR = '#FF8C00';

export default {
    name: 'CalendarTapeColorAssignments',
    components: {
        Page,
        ResponsiveButton,
        FormCheckbox,
    },
    data() {
        return {
            tabs: [
                {
                    id: 'ctConfigOptions',
                    title: 'Configuration Options',
                    active: false,
                    route: '/app/calendar-tape/options',
                },
                {
                    id: 'ctColorAssignments',
                    title: 'Color Assignments',
                    active: true,
                    route: '/app/calendar-tape/assignments',
                },
            ],
            choices: [],
            question: null,
            disabled: false,
        };
    },
    methods: {
        async fetchAssignments() {
            try {
                const { data } = await API.get(
                    CALENDAR_COLOR_ASSIGNMENT_ENDPOINT()
                );
                this.choices = data.map((item) => ({
                    ...item,
                    color: item.color || DISABLED_INPUT_COLOR,
                }));
            } catch (e) {
                this.errorToast({ text: 'Could not load data' });
            }
        },
        async fetchQuestion() {
            try {
                const questionResponse = await API.get(
                    CALENDAR_COLOR_ASSIGNMENT_QUESTION_ENDPOINT()
                );
                this.question = questionResponse.data.title;
            } catch (e) {
                this.errorToast({ text: 'Could not load data' });
            }
        },
        onColorChange(value, id) {
            const el = this.choices.find((item) => item.id === id);
            el.color = value;
        },
        async saveAssignments() {
            try {
                await API.patch(
                    CALENDAR_COLOR_ASSIGNMENT_SAVE_ENDPOINT(),
                    this.choices.map((item) => ({
                        id: item.id,
                        color: item.color,
                        disabled: item.disabled,
                    }))
                );
                this.fetchAssignments();
                this.successToast({ text: 'Assignments successfuly saved' });
            } catch (e) {
                this.errorToast({ text: 'Could not update data' });
            }
        },
    },
    mounted() {
        Promise.all[(this.fetchQuestion(), this.fetchAssignments())];
    },
};
</script>

<style lang="scss" scoped>
.color-picker {
    cursor: pointer;
    &::-webkit-color-swatch-wrapper {
        border: none;
    }
    &::-webkit-color-swatch {
        border: none;
    }
}
</style>